import { toISOString } from '../../common/functions';
import { getVertexId } from '../../core/util';
import type { CoreTypes } from '../../core';
import type { Types as SduiTypes } from '../types';

export default (
  event:   CoreTypes.Mixed.Event,
  options: SduiTypes.options
): SduiTypes.lesson => {
  const course_id = event.course ? getVertexId(event.course, options) : undefined;
  if (!course_id)
    throw new Error(`(Sdui::to::Lessons) Course is not missing for event ${ getVertexId(event, options) }`);

  const begins_at = toISOString(event.start);
  if (!begins_at)
    throw new Error(`(Sdui::to::Lessons) Start is not missing for event ${ getVertexId(event, options) }`);

  const ends_at = toISOString(event.end);
  if (!ends_at)
    throw new Error(`(Sdui::to::Lessons) End is not missing for event ${ getVertexId(event, options) }`);

  return {
    id:       getVertexId(event, options),
    course_id,
    begins_at,
    ends_at,
    teachers: (event.teachers ?? []).map(x => getVertexId(x.to, options)),
    classes:  (event.groups   ?? []).map(x => getVertexId(x.to, options)),
  };
};